import { render, staticRenderFns } from "./ChevronRightIcon.vue?vue&type=template&id=2306d205&"
import script from "./ChevronRightIcon.vue?vue&type=script&lang=ts&"
export * from "./ChevronRightIcon.vue?vue&type=script&lang=ts&"
import style0 from "./ChevronRightIcon.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports